import type {
  CoreProductPhoto,
  CoreProductPhotoPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Create product photo.
 *
 * @endpoint POST /api/saas/me/products/{productId}/photos
 * @scope saas
 * @see https://flecto.dev/api-4724236
 */

export async function createProductPhoto(
  productId: ParameterID,
  ProductPhoto: CoreProductPhotoPayload
): Promise<CoreProductPhoto> {
  const body: CoreProductPhotoPayload = ProductPhoto

  const response = await api.post(
    `/api/saas/me/products/${productId}/photos`,
    body
  )

  return response.data.product_photo
}
